import React from 'react';

const Fab = React.forwardRef((props, ref) => (
  <button ref={ref} onClick={props.onScroll} type="button" className="btn btn-fab" style={{ display: 'none' }} />
));
export default Fab;
